<app-button-toggle-group
  [options]="options"
  [variant]="variant"
  [size]="size"
  [initialValue]="initialValue"
  (handleChange)="handleChange($event)"
></app-button-toggle-group>
